import { useMemo } from 'react'
import i18n from '@/plugins/i18n'
import { useFetchPublicCatalogShowcasesQuery } from '@/store/api/publicCatalogApi'
import { Collection, COLLECTION_NO_VALUE } from '@/store/api/showcasesApi'
import { useAppSelector } from '@/store/hooks'
import { createFiltersSelector } from '@/store/slices/aggregatesSlice'
import { usePublicCatalogObjectives } from '../usePublicCatalogObjectives/usePublicCatalogObjectives'

const UNCATEGORIZED = [
  {
    name: i18n.t('collections.filter.uncategorized'),
    id: COLLECTION_NO_VALUE,
    code: 'uncategorized',
    description: '',
    objectivesCount: 0,
    order: Number.MAX_SAFE_INTEGER - 1,
  },
] as Collection[]

export const usePublicCollectionFilters = () => {
  const { data: collections = [], isLoading } = useFetchPublicCatalogShowcasesQuery()
  const { hasNoShowCase } = usePublicCatalogObjectives()

  const collectionFilters = useAppSelector((state) => createFiltersSelector(state, 'public').collection)

  return useMemo(() => {
    return {
      isLoading,
      collectionFilters: isLoading
        ? []
        : [...collections, ...(hasNoShowCase ? UNCATEGORIZED : [])].map((filter) => ({
            ...filter,
            isActive: collectionFilters.includes(filter.id),
          })),
    }
  }, [isLoading, collections, hasNoShowCase, collectionFilters])
}
